import {
  CalendarDayView,
  CalendarFilters,
  CalendarMonthView,
  CalendarToolbar,
  CalendarWeekView,
} from '@/modules/calendar/components';
import { useCalendarEvents, useReservationCalendar } from '@/modules/calendar/hooks';
import { eventsForDay } from '@/modules/calendar/utils';
import { Link } from 'react-router-dom';
import { modulePaths } from '@/routes/paths';

export function CalendarPage() {
  const {
    view,
    anchorDate,
    filters,
    visibleRange,
    setView,
    setFilters,
    navigatePrev,
    navigateNext,
    goToToday,
  } = useReservationCalendar();

  const { events, loading, error, refresh } = useCalendarEvents({
    visibleRange,
    filters,
  });

  const dayEvents =
    view === 'day' ? eventsForDay(events, anchorDate) : events;

  return (
    <section className="calendar-page">
      <div className="inventory-page-header">
        <h1>Agenda operativa</h1>
        <Link
          to={modulePaths.reservations}
          className="auth-button auth-button--secondary inventory-page-header__btn"
        >
          Ver reservas
        </Link>
      </div>

      <p className="auth-muted calendar-page__intro">
        Visualización temporal de reservas. Fuente de datos: colección{' '}
        <code>reservations</code> (sin colección de eventos separada).
      </p>

      <CalendarFilters filters={filters} onChange={setFilters} />

      <CalendarToolbar
        view={view}
        anchorDate={anchorDate}
        onViewChange={setView}
        onPrev={navigatePrev}
        onNext={navigateNext}
        onToday={goToToday}
      />

      {loading ? <p className="auth-muted">Cargando agenda…</p> : null}
      {error ? (
        <p className="auth-error">
          {error}{' '}
          <button type="button" className="link-button" onClick={() => void refresh()}>
            Reintentar
          </button>
        </p>
      ) : null}

      {!loading && !error ? (
        <div className="calendar-viewport">
          {view === 'month' ? (
            <CalendarMonthView anchorDate={anchorDate} events={events} />
          ) : null}
          {view === 'week' ? (
            <CalendarWeekView anchorDate={anchorDate} events={events} />
          ) : null}
          {view === 'day' ? (
            <CalendarDayView anchorDate={anchorDate} events={dayEvents} />
          ) : null}
        </div>
      ) : null}
    </section>
  );
}
